/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React from "react";
import classes from "./order.module.css";
import Tooltip from "@mui/material/Tooltip";
import { withTranslation } from "react-i18next";

import { IconButton } from "@mui/material";
import {
  ActivateIcon,
  ResendEmailIcon,
  ModifyIcon,
  CancelIcon,
  AutoActivatedIcon,
  DownloadIcon,
  ReturnIconBig,
  AcceptIcon,
  DiagramIcon,
  ProcessOrderIcon,
} from "../../../component/icons/icons";
import { useNavigate } from "react-router-dom";

const Action = (props) => {
  const { t } = props;
  const navigate = useNavigate();
  // const { autoActivatable, status, orderActivationStatus } = props;
  return (
    <div className={classes.actionIconsImg}>
      {(props.orderActivationStatus === "Ready For Activation" ||
        props.orderActivationStatus === "Partially Activated" ||
        props.orderActivationStatus === "Activated") && (
        <>
          <Tooltip title={t("ACTIVATE_ORDER_ITEMS")}>
            <IconButton
              onClick={() => {
                props.selectAction("activateOrder");
              }}
              className={"orderActionsIcon"}
            >
              <ActivateIcon />
              {/* <label style={{ color: props.color }}>{t("ACTIVATE")}</label> */}
            </IconButton>
          </Tooltip>{" "}
          &nbsp;
        </>
      )}
      {props.autoActivatable && (
        <>
          <Tooltip title={t("AUTO_ACTIVATED")}>
            <IconButton className={"orderActionsIcon"}>
              <AutoActivatedIcon />
              {/* <label style={{ color: props.color }}>
                {t("AUTO_ACTIVATED")}
              </label> */}
            </IconButton>
          </Tooltip>{" "}
          &nbsp;
        </>
      )}

      {props.providerType === "SALES_CHNL_PROVIDER" && (
        <>
          {props.status === "Waiting Customer Acceptance" ||
            (props.status === "Waiting For Customer Acceptance" && (
              <>
                <Tooltip title={t("RE-SEND_TERMS_&_CONDITIONS_EMAIL")}>
                  <IconButton
                    onClick={() => {
                      props.selectAction("resendMail");
                    }}
                    className={"orderActionsIcon"}
                  >
                    <ResendEmailIcon />
                    {/* <label style={{ color: props.color }}>{t("RE_SEND")}</label> */}
                  </IconButton>
                </Tooltip>{" "}
                &nbsp;
              </>
            ))}
          {(props.status === "Waiting Customer Acceptance" ||
            props.status === "Waiting For Customer Acceptance") &&
            (props.userPerms.includes("ORDERMGR_ADMIN") ||
              props.userPerms.includes("ORDERMGR_UPDATE")) && (
              <>
                <Tooltip title={t("MODIFY_ORDER")}>
                  <IconButton
                    onClick={() => {
                      props.selectAction("modifyOrder");
                    }}
                    className={"orderActionsIcon"}
                  >
                    <ModifyIcon />
                    {/* <label style={{ color: props.color }}>
                      {t("MODIFY_ORDER")}
                    </label> */}
                  </IconButton>
                </Tooltip>{" "}
                &nbsp;
              </>
            )}
          {props.userPerms.includes("ORDERMGR_RETURN") &&
            props.status === "Order Fulfilled" &&
            props.returnableItemList &&
            props.returnableItemList.length > 0 && (
              <>
                <Tooltip title={t("RETURN_ORDER_ITEMS")}>
                  <IconButton
                    onClick={() => {
                      navigate(`/return/${props.id}`);
                    }}
                    className={"orderActionsIcon"}
                  >
                    <ReturnIconBig />
                    {/* <label style={{ color: props.color }}>{t("RETURN")}</label> */}
                  </IconButton>
                </Tooltip>
                &nbsp;
              </>
            )}
          {props.processInstanceDiagram &&
            props.workFlowEnabled &&
            props.loggedInUserType !== "ECOMMERCE_CUSTOMER" &&
            props.loggedInUserType !== "ECOMMERCE_ADMIN" &&
            props.providerType === "SALES_CHNL_PROVIDER" && (
              <>
                <Tooltip title={t("VIEW_ORDER_INSTANCE_ID", { props })}>
                  <IconButton
                    onClick={() => {
                      props.openDiagramDialog();
                    }}
                    className={"orderActionsIcon"}
                  >
                    <DiagramIcon />
                    {/* <label style={{ color: props.color }}>{t("DIAGRAM")}</label> */}
                  </IconButton>
                </Tooltip>{" "}
                &nbsp;
              </>
            )}

          {/* {(props.loggedInUserType !== "ECOMMERCE_CUSTOMER" && props.loggedInUserType !== "ECOMMERCE_ADMIN") &&
                        props.status !== 'Order Fulfilled' &&
                        <>
                            <Tooltip title={t('PROCESS_ORDER')}>
                                <IconButton
                                    onClick={() => { props.togglePrtialProcessingDailog(false) }}
                                    className={'orderActionsIcon'}
                                >
                                    <ProcessOrderIcon />
                                    <label style={{ color: props.color }}>{t('PROCESS_ORDER')}</label>
                                </IconButton>
                            </Tooltip>&nbsp;
                        </>
                    } */}

          {/* {(props.loggedInUserType !== "ECOMMERCE_CUSTOMER" && props.loggedInUserType !== "ECOMMERCE_ADMIN") && (props.userPerms.includes('ORDERMGR_RETURN') || props.userPerms.includes('ORDERMGR_ADMIN') || props.userPerms.includes('ORDERMGR_UPDATE'))
                        && (props.workFlowEnabled && props.formFields && props.formFields.fields && props.formFields.fields.length > 0) &&
                        <>
                            <Tooltip title={t('ACTION_REQUIRED')}>
                                <IconButton
                                    onClick={() => { props.showActionDialog() }}
                                    className={'orderActionsIcon'}
                                >
                                    <AcceptIcon />
                                    <label style={{ color: props.color }}>{t('ACTION_REQUIRED')}</label>
                                </IconButton>
                            </Tooltip>&nbsp;
                        </>
                    } */}

          {(props.status === "Waiting Customer Acceptance" ||
            props.status === "Waiting For Customer Acceptance" ||
            props.status === "Review to be Completed") &&
            (props.userPerms.includes("ORDERMGR_RETURN") ||
              props.userPerms.includes("ORDERMGR_ADMIN") ||
              props.userPerms.includes("ORDERMGR_UPDATE")) && (
              <>
                <Tooltip title={t("CANCEL_ORDER")}>
                  <IconButton
                    onClick={() => {
                      props.selectAction("cancelOrder");
                    }}
                    className={"orderActionsIcon"}
                  >
                    <CancelIcon />
                    {/* <label style={{ color: props.color }}>{t("CANCEL")}</label> */}
                  </IconButton>
                </Tooltip>
                &nbsp;
              </>
            )}
          {props.downloadInvoice && (
            <>
              <Tooltip title={t("DOWNLOAD_INVOICE")}>
                <IconButton
                  onClick={() => {
                    props.downloadInvoicePdf();
                  }}
                  className={"orderActionsIcon"}
                >
                  <DownloadIcon />
                  {/* <label style={{ color: props.color }}>{t("DOWNLOAD")}</label> */}
                </IconButton>
              </Tooltip>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default withTranslation("translations")(Action);
